module.exports = __webpack_public_path__ + "static/media/aMediaBlack.319828a6.png";